class ValidationError {
  static isInvalid(error, prop) {
    if (!(error instanceof ValidationError)) return false;
    return error.errors &&
      error.errors[prop] &&
      error.errors[prop] !== undefined;
  }

  static isInvalids(error, props) {
    for (let i = 0; i <= props.length; i++) {
      const invalid = this.isInvalid(error, props[i]);
      if (invalid) {
        return invalid;
      }
    }
  }

  static getError(error, prop) {
    if (!(error instanceof ValidationError)) return false;
    return error.errors[prop] ? error.errors[prop][0].message : "";
  }

  constructor(errors, message) {
    if (message || message === "") {
      this.errors = [];
      this.errors[errors] = [];
      this.errors[errors].push({
        message: message
      });
    } else {
      this.errors = errors;
    }
  }
}

export default ValidationError;



/** WEBPACK FOOTER **
 ** ./src/common/lib/validation/ValidationError.js
 **/